export const getActiveCaregiver = () => {
  const activeCaregiver = localStorage.getItem('activeCaregiver');
  return {
    activeCaregiver: activeCaregiver ? JSON.parse(activeCaregiver) : null,
  };
};

export const setActiveCaregiver = (caregiver) => {
  if (caregiver) {
    localStorage.setItem('activeCaregiver', JSON.stringify(caregiver));
  }
};

export const removeActiveCaregiver = () => {
  localStorage.removeItem('activeCaregiver');
};

export const caregiverTitle = (caregiver) => {
  if (!caregiver) return '';

  const titles = {
    active: 'Active Caregivers',
    archived: 'Archived Caregivers',
    rejected: 'Rejected Caregivers',
    applicant: 'Applicant Caregivers',
  };

  return titles[caregiver.toLowerCase()] || '';
};
